var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct("update-bookyear-title", { bookYear: _vm.bookYear }))
        ),
      ]),
      _c(
        "w-card-content",
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$ct("update-bookyear-info", {
                  bookYear: _vm.bookYear,
                  previous: _vm.bookYear - 1,
                })
              )
            ),
          ]),
          _c("w-checkbox", {
            attrs: {
              label: _vm.$ct("update-depreciations", {
                bookYear: _vm.bookYear,
                previous: _vm.bookYear - 1,
              }),
            },
            model: {
              value: _vm.doDepreciations,
              callback: function ($$v) {
                _vm.doDepreciations = $$v
              },
              expression: "doDepreciations",
            },
          }),
          _c("w-checkbox", {
            attrs: {
              disabled: !_vm.hasPreviousBookYear,
              label: _vm.$ct("update-opening-balance", {
                bookYear: _vm.bookYear,
                previous: _vm.bookYear - 1,
              }),
            },
            model: {
              value: _vm.doOpeningBalance,
              callback: function ($$v) {
                _vm.doOpeningBalance = $$v
              },
              expression: "doOpeningBalance",
            },
          }),
          _vm.status
            ? _c("div", { staticClass: "mt" }, [
                _vm.status.LastOpeningBalanceDate
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct("last-opening-balance", _vm.statusParams)
                          ) +
                          " "
                      ),
                    ])
                  : _c("p", [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("no-opening-balance-yet")) + " "
                      ),
                    ]),
                _vm.status.ManualGroups.length > 0
                  ? _c(
                      "div",
                      { staticClass: "manual-groups" },
                      [
                        _c("p", { staticClass: "warning-text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("manual-groups-warning")) + " "
                          ),
                        ]),
                        _c(
                          "w-list",
                          _vm._l(_vm.status.ManualGroups, function (group) {
                            return _c(
                              "w-list-item",
                              { key: group.GroupID },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(
                                    _vm._s(group.GroupID) +
                                      " - " +
                                      _vm._s(group.Comment) +
                                      " (" +
                                      _vm._s(group.Lines) +
                                      ")"
                                  ),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        staticClass: "danger",
                                        attrs: {
                                          icon: "trash",
                                          disabled: _vm.busy,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteManualGroup(group)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$ct("common.delete")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.result
            ? _c("div", { staticClass: "mt result" }, [
                _vm.result.PreviousDepreciations
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              "result-depreciations",
                              _vm.result.PreviousDepreciations
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.result.OpeningBalance
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              "result-opening-balance",
                              _vm.openingBalanceParams
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.result.OpeningBalance &&
                _vm.result.OpeningBalance.CentralsOnSuspense &&
                !_vm.result.OpeningBalance.SaldoDocumentsFound
                  ? _c("p", { staticClass: "warning-text" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$ct("warning-no-saldo-documents")) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _vm.result.Depreciations
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              "result-depreciations",
                              _vm.result.Depreciations
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.close")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                icon: "check",
                disabled:
                  _vm.busy || (!_vm.doDepreciations && !_vm.doOpeningBalance),
              },
              on: {
                click: function ($event) {
                  return _vm.run()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }